<template>
  <div class="c-accordion" :class="{ 'c-accordion--open': isOpen }">
    <div class="c-accordion__head" @click="toggle()">
      <span>{{ label }}</span>
      <svg
        width="26"
        height="10"
        viewbox="0 0 26 10"
        version="1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 2l11 6 11-6"
          fill-rule="nonzero"
          stroke="#FFF"
          stroke-width="2"
          fill="none"
          stroke-linecap="square"
        />
      </svg>
    </div>
    <div class="c-accordion__body" v-if="isOpen">
      <div class="content o-wysiwyg">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    label: String,
  },
  data: () => ({
    isOpen: false,
  }),
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss">
@import "../../../../_scss/_vars.scss";
@import "../../../../_scss/utils/utils.scss";

.c-accordion {
  margin-bottom: 10px;

  &__head {
    cursor: pointer;
    background-color: $c-primary;
    color: #fff;
    font-size: rem(15px);
    padding: rem(20px) rem(17px);
    text-transform: uppercase;
    font-weight: $f-bold;

    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      max-width: 80%;
    }

    svg {
      transition: $t-hover;
      transform: rotate(360deg) scale(0.8);
    }
  }

  &__body {
    // border: 1px solid $c-primary;
    padding: rem(22px) rem(17px);
    background-color: #e8e0da;
  }

  &--open {
    .c-accordion {
      &__head {
        svg {
          transform: rotate(180deg) scale(0.8);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// assets/_js/components/vue/blocks/Accordion.vue